import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import moment from 'moment-timezone';
import ModernDatepicker from 'react-modern-datepicker';
import { uploadCoursesAndTraining } from '../../app/store/actions/coursesAndTraining';
import FIELDS from '../../data/fields';
import ROUTES from '../../data/routes';
import { history } from '../../routers/AppRouter';
import HeaderComponent from '../table/header/headerComponent';

class CoursesAndTrainingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coursesAndTrainingId: null,
      line: '',
      category: '',
      name: '',
      certificate: '',
      numberOfStudents: '',
      courseDate: moment().startOf(''),
      courseTime: '',
      instructors: '',
      message: '',
      success: '',
    };
  }

  componentDidMount = () => {
    if (this.props.back.location.selectedLine) {
      this.setTheVariables(this.props.back.location.selectedLine);
    }
  }

  setTheVariables = (selectedLine) => {
    this.setState({
      coursesAndTrainingId: selectedLine.id,
      line: selectedLine.line,
      category: selectedLine.category,
      name: selectedLine.name,
      certificate: selectedLine.certificate,
      numberOfStudents: selectedLine.numberOfStudents,
      courseDate: moment(selectedLine.courseDate).format('DD-MM-YYYY'),
      courseTime: selectedLine.courseTime,
      instructors: selectedLine.instructors,
    });
  }

  setValue = (att, value) => {
    this.setState({ [att]: value });
  }

  updateData = async () => {
    const {
      coursesAndTrainingId, line, category, name, certificate,
      numberOfStudents, courseDate, courseTime, instructors,
    } = this.state;
    try {
      await this.props.uploadCoursesAndTraining({
        coursesAndTrainingId,
        line,
        category,
        name,
        certificate,
        numberOfStudents,
        courseDate,
        courseTime,
        instructors,
      });
      await this.setState({
        success: I18n.t('changeMade'),
        message: '',
      });
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          success: '',
          message: messageError,
        });
      } else {
        this.setState({
          success: '',
          message: I18n.t('erroFetch'),
        });
      }
    }
  }

  goBack = () => history.push(ROUTES.COURSES_AND_TRAINING);

  render() {
    const {
      line, category, name, certificate, numberOfStudents,
      courseDate, courseTime, instructors,
    } = this.state;

    return (
      <div className="form-main">
        <HeaderComponent
          title={I18n.t('UpdateCoursesAndTraining')}
        />
        <form>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('line')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('line', e.target.value)}
              value={line}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('category')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('category', e.target.value)}
              value={category}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('courseName')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('name', e.target.value)}
              value={name}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('certificate')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('certificate', e.target.value)}
              value={certificate}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('numberOfStudents')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('numberOfStudents', e.target.value)}
              value={numberOfStudents}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('date')}
            </p>
            <ModernDatepicker
              date={courseDate}
              format="DD-MM-YYYY"
              showBorder
              onChange={date => this.setValue('courseDate', date)}
              placeholder=""
              className="form-control"
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('Hour')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('courseTime', e.target.value)}
              value={courseTime}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('instructors')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('instructors', e.target.value)}
              value={instructors}
            />
          </div>
          <div className="row margin-left-0 margin-top-10">
            <button
              className="btn btn-warning margin-right-15"
              type="button"
              onClick={this.goBack}
            >
              {I18n.t('return')}
            </button>

            <button
              className="btn btn-dark margin"
              type="button"
              onClick={this.updateData}
            >
              {I18n.t('update')}
            </button>
          </div>
        </form>
        {!!this.state.success && <p className="color-green margin-top-10">{this.state.success}</p>}
        {!!this.state.message && <p className="color-red margin-top-10">{this.state.message}</p>}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadCoursesAndTraining: coursesAndTrainingParameter => dispatch(
    uploadCoursesAndTraining(coursesAndTrainingParameter),
  ),
});

const mapStateToProps = (/* state */) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(CoursesAndTrainingForm);
